import { QuestionnaireOverview } from "src/api/client-api/company/overview/useOrganizationOverview";
import { URLHandler } from "src/services/URLHandler";
import { SummaryBlockOverview } from "./SummaryBlockOverview";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useTranslation } from "react-i18next";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { getSsqDisplayTitle } from "src/utils/ssqTitle";

type BodyOverviewProps = {
    overview: QuestionnaireOverview;
};
export const BodyOverview = (props: BodyOverviewProps) => {
    const { overview } = props;
    const { t } = useTranslation();
    const { currentCampaign } = useFoodpilotContext();
    const { company } = useCompanyMetadata();

    const completion = overview.post?.completion ?? 0;
    const isLocked = overview.post?.isLocked ?? false;
    const canViewSsq = overview.post ? overview.post.canViewSsq : true;
    // Easy way to get first item or undefined
    const score = overview.scores?.find((i) => true);
    const scoreId = score?.id.toString();

    const campaignId = currentCampaign?.id;
    const link =
        campaignId !== undefined && scoreId !== undefined ?
            URLHandler.company.questionnaireScore(company.id, overview.id, campaignId, scoreId)
        :   undefined;

    return (
        <SummaryBlockOverview
            title={{
                label: getSsqDisplayTitle(overview),
                tag: completion > 0 && completion <= 75 ? "incomplete" : undefined,
            }}
            isLocked={isLocked}
            canViewSsq={canViewSsq}
            completion={{
                progress: completion ?? 0,
                label: `${completion ?? 0}%`,
                info: t("company.dashboard.percent_subtitle"),
                colorIndex: 4,
            }}
            link={{
                goTo: link,
            }}
        />
    );
};
